import React from "react";
import "../../../styles/layout.css";
import EASelect from "../../EASelect";
import EATextField from "../../EATextField";

/**
 * Form zur Darstellung persönlicher Daten eines Users
 * @param person die anzuzeigenden Personendaten
 * @param anredeOptions die Optionen für die Anrede
 * @param titelOptions die Optionen für die Titel
 * @param handlePersonChanged die aufzurufende Methode bei Änderung eines Wertes
 * @param errors Die Fehlermeldungen, welche an die Felder der Komponente weitergeleitet werden sollen
 * @param additionalChildren Hier können zusätzliche Komponenten angegeben werden die unter E-Mail angezeigt werden sollen
 * @param additionalPrefixChildren Hier können zusätzliche Komponenten angegeben werden die oberhalb der Personendaten angezeigt werden sollen
 * @param additionalPersonField
 * @returns {JSX.Element}
 * @constructor
 */
function PersonalDataComponent({
                                   person,
                                   anredeOptions,
                                   titelOptions,
                                   handlePersonChanged,
                                   errors,
                                   additionalChildren = null,
                                   additionalPrefixChildren = null,
                                   _additionalPersonField = "benutzername",
                               }) {
    function createRequiredPersonTextField(labelText, personField, additionalPersonField) {
        return createPersonTextField(labelText, personField, true, additionalPersonField);
    }

    function createPersonTextField(labelText, personField, required, additionalPersonField) {
        const errorsToBeShown =
            additionalPersonField && errors[additionalPersonField] ? errors[additionalPersonField] : errors[personField];
        return (
            <EATextField
                required={required}
                id={`Person.${labelText}`}
                label={`${labelText}`}
                value={person[personField] ? person[personField] : ""}
                onChange={(e) => handlePersonChanged(personField, e.target.value)}
                error={errorsToBeShown}
            />
        );
    }

    function createPersonSelect(labelText, personField, options, required = false) {
        return (
            <EASelect
                label={labelText}
                loading={options.loading}
                options={options.data ? options.data : []}
                optionTitle="value"
                optionKey="id"
                value={person[personField] ? person[personField] : ""}
                error={errors[personField]}
                onChange={(newValue) => handlePersonChanged(personField, newValue)}
                required={required}
            />
        );
    }

    return (
        <div className="gridl cols-2">
            {additionalPrefixChildren}
            {createPersonSelect("Anrede", "anrede", anredeOptions, true)}
            {createPersonSelect("Titel", "titel", titelOptions)}
            {createRequiredPersonTextField("Vorname", "vorname")}
            {createRequiredPersonTextField("Name", "name")}
            {createRequiredPersonTextField("Telefon", "telefon")}
            {createPersonTextField("Mobil", "mobil", false)}
            {createRequiredPersonTextField("E-Mail", "email")}
            {additionalChildren}
        </div>
    );
}

export default PersonalDataComponent;
